import ExcelJS from 'exceljs';
import type { AdSpendTableConfig, StatType } from './AdSpendReport.config';
import { format } from 'date-fns';
import { PackageTypes } from '../../../../utils/packageTypes';

export const downloadAdspendExcel = async (
  stats: Array<StatType>,
  config: Array<AdSpendTableConfig>,
  fileName?: string,
) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Ad Spend');

  const headers = config.map((config) => config.header);
  worksheet.addRow(headers);

  stats.forEach((stat) => {
    const row = config.map((config) => {
      const value = config.field ? stat[config.field] : stat;
      const render = config.csvRenderer ?? ((val: unknown) => val);

      return render(value, stat);
    });

    worksheet.addRow(row);
  });

  const excelName = fileName ?? `Ad_Spend_${format(new Date(), 'yyyy_MMMM_dd')}.xlsx`;
  downloadExcel(excelName, workbook);
};

type ExcelSheet = {
  sheetName: string;
  stats: Array<StatType>;
  config: Array<AdSpendTableConfig>;
};

export const downloadAdspendExcelMultiSheet = async (sheets: Array<ExcelSheet>, fileName: string) => {
  const workbook = new ExcelJS.Workbook();

  sheets.forEach(({ sheetName, stats, config }) => {
    const worksheet = workbook.addWorksheet(sheetName);

    const headers = config.map((c) => c.header);
    worksheet.addRow(headers);

    stats.forEach((stat) => {
      const row = config.map((c) => {
        const value = c.field ? stat[c.field] : stat;
        const render = c.csvRenderer ?? ((val: unknown) => val);
        return render(value, stat);
      });
      worksheet.addRow(row);
    });
  });

  downloadExcel(fileName, workbook);
};

export const filterStatsForExtend = (stats: Array<StatType>): Array<StatType> => {
  return stats.filter((stat) => {
    return stat.addOnBoostCost > 0 || stat.addOnImpressions > 0 || stat.addOnClickCount > 0;
  });
};

export const filterStatsForBoost = (stats: Array<StatType>): Array<StatType> => {
  return stats.filter((stat) => {
    if (stat.adproductTypes.some((type) => PackageTypes.has(type))) {
      return false;
    }
    if (stat.insertionOrderId) {
      return true;
    }
    const hasBoostCost = !!stat.boostCost;
    const hasBoostImpressions = !!stat.boostImpressions;
    const hasCpmBoostTypes = stat.cpmBoostTypes?.length > 0;
    return hasBoostCost || hasBoostImpressions || hasCpmBoostTypes;
  });
};

export const downloadExcel = async (fileName: string, workbook: ExcelJS.Workbook) => {
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(link.href);
};
